import {
  essHandleSelectProgram,
  essHandleUnselectAllProgram,
  handleAddHeatingSchedule,
  handleClearHeatingSchedule,
  handleEssGraph,
  handleEssGraphDate,
  handleEssSSRState,
  handleEssSwitchSocket,
  handleExpandSSRDetail,
  handleInstantHeatOff,
  handleInstantHeatReady,
  handleMachineOptionalConstantTempOff,
  handleOpenMachineController,
  handleOptionalConstantTempReady,
  handleReadyHeatingSchedule,
  handleShutOff,
  handleSnowSensor,
  handleSnowSensorOff,
  handleWindFactor,
  handleWindFactorOff,
} from './essSwitchSlice';
import {
  handleTgsGraph,
  handleTgsGraphDate,
  handleTgsSwitchSocket,
  tgsActivateConflictMessage,
  tgsDeactivateConflictMessage,
  tgsHandleAddHeatingSchedule,
  tgsHandleClearHeatingSchedule,
  tgsHandleFanOnly,
  tgsHandleInstantHeat,
  tgsHandleInstantHeatOff,
  tgsHandleOpenMachineController,
  tgsHandleReadyHeatingSchedule,
  tgsHandleSelectProgram,
  tgsHandleShutOff,
  tgsHandleSnowSensor,
  tgsHandleSnowSensorOff,
  tgsHandleUnselectAllProgram,
  tgsHandleWindFactor,
  tgsHandleWindFactorOff,
  tgsSetDevicesConflicts,
} from './tgsSwitchSlice';
import {
  handleTesGraph,
  handleTesGraphDate,
  handleTesSSRState,
  handleTesSwitchSocket,
  tesActivateConflictMessage,
  tesDeactivateConflictMessage,
  tesHandleAddHeatingSchedule,
  tesHandleClearHeatingSchedule,
  tesHandleExpandSSRDetail,
  tesHandleInstantHeat,
  tesHandleInstantHeatOff,
  tesHandleOpenMachineController,
  tesHandleOptionalConstantTempIsReady,
  tesHandleOptionalConstantTempOff,
  tesHandleReadyHeatingSchedule,
  tesHandleSelectProgram,
  tesHandleShutOff,
  tesHandleSnowSensor,
  tesHandleSnowSensorOff,
  tesHandleUnselectAllProgram,
  tesHandleWindFactor,
  tesHandleWindFactorOff,
  tesSetDevicesConflicts,
} from './tesSwitchSlice';

// Where each system's switch state lives (`state[sliceKey][treeKey|flatKey]`),
// and the per-system actions shared hooks and components dispatch.
// An action a system doesn't have is `undefined`: TGS has no SSRs (so no SSR
// state or SSR panel) and no constant temp, only TGS has a fan, and ESS never
// asks about a conflict.
export const SWITCH_SLICES = Object.freeze({
  ess: Object.freeze({
    sliceKey: 'essSwitch',
    treeKey: 'essSwitch',
    flatKey: 'flatEssSwitch',
    setGraph: handleEssGraph,
    setGraphDate: handleEssGraphDate,
    setSSRState: handleEssSSRState,
    addSchedule: handleAddHeatingSchedule,
    updateDevice: handleEssSwitchSocket,
    instantHeatOn: handleInstantHeatReady,
    instantHeatOff: handleInstantHeatOff,
    constantTempOn: handleOptionalConstantTempReady,
    constantTempOff: handleMachineOptionalConstantTempOff,
    fanOnly: undefined,
    snowSensorOn: handleSnowSensor,
    snowSensorOff: handleSnowSensorOff,
    windFactorOn: handleWindFactor,
    windFactorOff: handleWindFactorOff,
    setScheduleReady: handleReadyHeatingSchedule,
    clearSchedule: handleClearHeatingSchedule,
    selectProgram: essHandleSelectProgram,
    unselectPrograms: essHandleUnselectAllProgram,
    showConflict: undefined,
    hideConflict: undefined,
    setConflict: undefined,
    shutOff: handleShutOff,
    openController: handleOpenMachineController,
    expandSSRDetail: handleExpandSSRDetail,
  }),
  tgs: Object.freeze({
    sliceKey: 'tgsSwitch',
    treeKey: 'tgsSwitch',
    flatKey: 'flatTgsSwitch',
    setGraph: handleTgsGraph,
    setGraphDate: handleTgsGraphDate,
    setSSRState: undefined,
    addSchedule: tgsHandleAddHeatingSchedule,
    updateDevice: handleTgsSwitchSocket,
    instantHeatOn: tgsHandleInstantHeat,
    instantHeatOff: tgsHandleInstantHeatOff,
    constantTempOn: undefined,
    constantTempOff: undefined,
    fanOnly: tgsHandleFanOnly,
    snowSensorOn: tgsHandleSnowSensor,
    snowSensorOff: tgsHandleSnowSensorOff,
    windFactorOn: tgsHandleWindFactor,
    windFactorOff: tgsHandleWindFactorOff,
    setScheduleReady: tgsHandleReadyHeatingSchedule,
    clearSchedule: tgsHandleClearHeatingSchedule,
    selectProgram: tgsHandleSelectProgram,
    unselectPrograms: tgsHandleUnselectAllProgram,
    showConflict: tgsActivateConflictMessage,
    hideConflict: tgsDeactivateConflictMessage,
    setConflict: tgsSetDevicesConflicts,
    shutOff: tgsHandleShutOff,
    openController: tgsHandleOpenMachineController,
    expandSSRDetail: undefined,
  }),
  tes: Object.freeze({
    sliceKey: 'tesSwitch',
    treeKey: 'tesSwitch',
    flatKey: 'flatTesSwitch',
    setGraph: handleTesGraph,
    setGraphDate: handleTesGraphDate,
    setSSRState: handleTesSSRState,
    addSchedule: tesHandleAddHeatingSchedule,
    updateDevice: handleTesSwitchSocket,
    instantHeatOn: tesHandleInstantHeat,
    instantHeatOff: tesHandleInstantHeatOff,
    constantTempOn: tesHandleOptionalConstantTempIsReady,
    constantTempOff: tesHandleOptionalConstantTempOff,
    fanOnly: undefined,
    snowSensorOn: tesHandleSnowSensor,
    snowSensorOff: tesHandleSnowSensorOff,
    windFactorOn: tesHandleWindFactor,
    windFactorOff: tesHandleWindFactorOff,
    setScheduleReady: tesHandleReadyHeatingSchedule,
    clearSchedule: tesHandleClearHeatingSchedule,
    selectProgram: tesHandleSelectProgram,
    unselectPrograms: tesHandleUnselectAllProgram,
    showConflict: tesActivateConflictMessage,
    hideConflict: tesDeactivateConflictMessage,
    setConflict: tesSetDevicesConflicts,
    shutOff: tesHandleShutOff,
    openController: tesHandleOpenMachineController,
    expandSSRDetail: tesHandleExpandSSRDetail,
  }),
});
